module.exports = __webpack_public_path__ + "img/about_img2.aef6d32f.png";